module["exports"] = [
  "Alligator mississippiensis",
  "Chinese Alligator",
  "Black Caiman",
  "Broad-snouted Caiman",
  "Spectacled Caiman",
  "Yacare Caiman",
  "Cuvier’s Dwarf Caiman",
  "Schneider’s Smooth-fronted Caiman",
  "African Slender-snouted Crocodile",
  "American Crocodile",
  "Australian Freshwater Crocodile",
  "Cuban Crocodile",
  "Dwarf Crocodile",
  "Morelet’s Crocodile",
  "Mugger Crocodile",
  "New Guinea Freshwater Crocodile",
  "Nile Crocodile",
  "West African Crocodile",
  "Orinoco Crocodile",
  "Philippine Crocodile",
  "Saltwater Crocodile",
  "Siamese Crocodile",
  "Gharial",
  "Tomistoma"
]